import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import authReducer from "../features/auth/store/authSlice";
import notificationReducer from "../features/notification/store/notificationSlice";
import hubspotReducer from "../features/integrations/store/hubspotSlice";

// Persist configuration for auth
const authPersistConfig = {
  key: "auth",
  storage,
};

// Persist configuration for notifications
const notificationPersistConfig = {
  key: "notifications",
  storage,
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedNotificationReducer = persistReducer(notificationPersistConfig, notificationReducer);

// Configure the store
export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    notifications: persistedNotificationReducer,
    // Deliberately NOT persisted: the HubSpot connection is server state that can
    // change outside this browser (token expiry, the user uninstalling the app from
    // the HubSpot side, an admin revoking it). A rehydrated snapshot would render a
    // dead integration as "Connected" until the next fetch resolved.
    hubspot: hubspotReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"], // Ignore redux-persist actions
      },
    }),
});

// Create a persistor
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;